(function () {
  'use strict';

  /*
   * ELYAH — Complete seu Look
   *
   * REGRAS ATUAIS
   * --------------------------------------------------
   * - 3 complementares definidos manualmente no admin.
   * - BANHO do produto principal = preferência inicial.
   * - Cliente pode escolher BANHO individualmente.
   * - Escolha manual do complementar não é sobrescrita.
   * - Total = principal + complementares selecionados.
   * - "Adicionar look" adiciona principal + selecionados.
   * - Se a MESMA variante principal já estiver no carrinho,
   *   ela não é adicionada novamente.
   * - Produto principal é enviado por último para aparecer
   *   visualmente no topo do cart drawer da ELYAH.
   * - Utiliza o cart drawer nativo do tema.
   * - Mensagens de erro somem automaticamente após 4 segundos.
   */

  function formatMoney(cents) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format((Number(cents) || 0) / 100);
  }

  function normalizeValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  /*
   * --------------------------------------------------
   * MENSAGENS
   * --------------------------------------------------
   */

  function hideMessage(container) {
    const errorBox = container.querySelector(
      '[data-complete-look-error]'
    );

    if (!errorBox) {
      return;
    }

    errorBox.textContent = '';
    errorBox.classList.remove('is-visible');

    if (container._completeLookMessageTimer) {
      clearTimeout(
        container._completeLookMessageTimer
      );

      container._completeLookMessageTimer = null;
    }
  }

  function showMessage(
    container,
    message
  ) {
    const errorBox = container.querySelector(
      '[data-complete-look-error]'
    );

    if (!errorBox) {
      return;
    }

    /*
     * Se já havia outro contador,
     * cancela antes de iniciar um novo.
     */
    if (container._completeLookMessageTimer) {
      clearTimeout(
        container._completeLookMessageTimer
      );
    }

    errorBox.textContent = message;
    errorBox.classList.add('is-visible');

    /*
     * Some automaticamente
     * após 4 segundos.
     */
    container._completeLookMessageTimer =
      setTimeout(function () {
        errorBox.classList.remove(
          'is-visible'
        );

        /*
         * Espera um pouco antes de
         * remover o texto para permitir
         * futura animação CSS.
         */
        setTimeout(function () {
          if (
            !errorBox.classList.contains(
              'is-visible'
            )
          ) {
            errorBox.textContent = '';
          }
        }, 250);

        container._completeLookMessageTimer =
          null;
      }, 4000);
  }

  /*
   * --------------------------------------------------
   * VARIANTES DOS COMPLEMENTARES
   * --------------------------------------------------
   */

  function readVariants(item) {
    const script = item.querySelector(
      '[data-complete-look-variants]'
    );

    if (!script) {
      return [];
    }

    try {
      return JSON.parse(
        script.textContent
      );
    } catch (error) {
      console.error(
        'Complete seu Look: erro ao ler variantes do complementar.',
        error
      );

      return [];
    }
  }

  /*
   * --------------------------------------------------
   * PRODUTO PRINCIPAL
   * --------------------------------------------------
   */

  function getMainVariantData(container) {
    const productDetail =
      container.closest(
        '.product-detail'
      );

    if (!productDetail) {
      return null;
    }

    const form =
      productDetail.querySelector(
        '.product-form'
      );

    const variantContainer =
      productDetail.querySelector(
        '.product-variant'
      );

    if (!form || !variantContainer) {
      return null;
    }

    const variantInput =
      form.querySelector(
        'input[name="id"]'
      );

    const variantJson =
      variantContainer.querySelector(
        'script[type="application/json"]'
      );

    if (!variantInput || !variantJson) {
      return null;
    }

    let variants = [];

    try {
      variants =
        JSON.parse(
          variantJson.textContent
        );
    } catch (error) {
      console.error(
        'Complete seu Look: erro ao ler variantes do produto principal.',
        error
      );

      return null;
    }

    const currentVariantId =
      String(
        variantInput.value
      );

    const selectedVariant =
      variants.find(
        function (variant) {
          return (
            String(variant.id) ===
            currentVariantId
          );
        }
      );

    if (!selectedVariant) {
      return null;
    }

    let banho = null;
    let banhoIndex = -1;

    const optionContainers =
      variantContainer.querySelectorAll(
        '.product-variant__option'
      );

    optionContainers.forEach(
      function (
        optionContainer,
        index
      ) {
        const content =
          normalizeValue(
            optionContainer.textContent
          );

        if (
          content.includes('banho') &&
          banhoIndex === -1
        ) {
          banhoIndex = index;

          const checkedRadio =
            optionContainer.querySelector(
              'input[type="radio"]:checked'
            );

          const select =
            optionContainer.querySelector(
              'select'
            );

          banho =
            checkedRadio?.value ||
            select?.value ||
            selectedVariant.options[index] ||
            null;
        }
      }
    );

    /*
     * Segunda tentativa:
     * procura BANHO no name.
     */
    if (!banho) {
      const checkedRadios =
        variantContainer.querySelectorAll(
          'input[type="radio"]:checked'
        );

      checkedRadios.forEach(
        function (radio) {
          if (
            normalizeValue(
              radio.name
            ).includes('banho')
          ) {
            banho = radio.value;
          }
        }
      );
    }

    /*
     * Fallback atual da ELYAH.
     */
    if (
      !banho &&
      selectedVariant.options &&
      selectedVariant.options.length
    ) {
      banho =
        selectedVariant.options[0];
    }

    return {
      variant: selectedVariant,
      banho: banho,
      banhoIndex: banhoIndex
    };
  }

  /*
   * --------------------------------------------------
   * VARIANTE DOS COMPLEMENTARES
   * --------------------------------------------------
   */

  function findAvailableVariant(
    item,
    desiredBanho
  ) {
    const variants =
      readVariants(item);

    const banhoIndex =
      Number(
        item.dataset.banhoIndex
      );

    if (!variants.length) {
      return null;
    }

    /*
     * Produto possui BANHO.
     */
    if (banhoIndex >= 0) {
      if (desiredBanho) {
        const matchingVariant =
          variants.find(
            function (variant) {
              return (
                variant.available &&
                normalizeValue(
                  variant.options[
                    banhoIndex
                  ]
                ) ===
                normalizeValue(
                  desiredBanho
                )
              );
            }
          );

        if (matchingVariant) {
          return matchingVariant;
        }
      }

      /*
       * O banho desejado não existe.
       * Usa outra variante disponível.
       */
      return (
        variants.find(
          function (variant) {
            return variant.available;
          }
        ) || null
      );
    }

    /*
     * Produto sem opção BANHO.
     */
    return (
      variants.find(
        function (variant) {
          return variant.available;
        }
      ) || null
    );
  }

  function getVariantImage(variant) {
    if (
      variant &&
      variant.featured_image &&
      variant.featured_image.src
    ) {
      return variant.featured_image.src;
    }

    return null;
  }

  function applyVariant(
    item,
    variant
  ) {
    const checkbox =
      item.querySelector(
        '[data-complete-look-checkbox]'
      );

    const price =
      item.querySelector(
        '[data-complete-look-price]'
      );

    const image =
      item.querySelector(
        '.complete-look__image img'
      );

    /*
     * Nenhuma variante disponível.
     */
    if (!variant) {
      item.classList.add(
        'is-unavailable'
      );

      item.classList.remove(
        'is-selected'
      );

      delete item.dataset.variantId;
      delete item.dataset.variantPrice;

      if (checkbox) {
        checkbox.checked = false;
        checkbox.disabled = true;
      }

      return;
    }

    /*
     * Variante disponível.
     */
    item.classList.remove(
      'is-unavailable'
    );

    if (checkbox) {
      checkbox.disabled = false;
    }

    item.dataset.variantId =
      String(variant.id);

    item.dataset.variantPrice =
      String(
        variant.price || 0
      );

    if (price) {
      price.textContent =
        formatMoney(
          variant.price
        );
    }

    /*
     * Atualiza imagem da variante
     * quando existir.
     */
    if (image) {
      if (
        !item.dataset.originalImage
      ) {
        item.dataset.originalImage =
          image.currentSrc ||
          image.src ||
          '';
      }

      const variantImage =
        getVariantImage(
          variant
        );

      if (variantImage) {
        image.src =
          variantImage;

        image.removeAttribute(
          'srcset'
        );
      } else if (
        item.dataset.originalImage
      ) {
        image.src =
          item.dataset.originalImage;
      }
    }
  }

  /*
   * --------------------------------------------------
   * SINCRONIZAÇÃO INICIAL
   * --------------------------------------------------
   */

  function setInitialCardVariant(
    item,
    mainBanho
  ) {
    /*
     * A cliente alterou manualmente.
     * Não sobrescrevemos mais.
     */
    if (
      item.dataset.manualVariant ===
      'true'
    ) {
      return;
    }

    const banhoSelect =
      item.querySelector(
        '[data-complete-look-banho]'
      );

    let desiredBanho =
      mainBanho;

    if (
      banhoSelect &&
      desiredBanho
    ) {
      const options =
        Array.from(
          banhoSelect.options
        );

      const matchingOption =
        options.find(
          function (option) {
            return (
              !option.disabled &&
              normalizeValue(
                option.value
              ) ===
              normalizeValue(
                desiredBanho
              )
            );
          }
        );

      if (matchingOption) {
        banhoSelect.value =
          matchingOption.value;
      } else {
        const firstAvailable =
          options.find(
            function (option) {
              return !option.disabled;
            }
          );

        if (firstAvailable) {
          banhoSelect.value =
            firstAvailable.value;

          desiredBanho =
            firstAvailable.value;
        }
      }
    }

    const variant =
      findAvailableVariant(
        item,
        banhoSelect
          ? banhoSelect.value
          : desiredBanho
      );

    applyVariant(
      item,
      variant
    );
  }

  /*
   * --------------------------------------------------
   * ITENS SELECIONADOS
   * --------------------------------------------------
   */

  function getSelectedItems(
    container
  ) {
    return Array.from(
      container.querySelectorAll(
        '[data-complete-look-item]'
      )
    ).filter(
      function (item) {
        const checkbox =
          item.querySelector(
            '[data-complete-look-checkbox]'
          );

        return (
          checkbox &&
          checkbox.checked &&
          !checkbox.disabled &&
          item.dataset.variantId
        );
      }
    );
  }

  /*
   * --------------------------------------------------
   * TOTAL DO LOOK
   * --------------------------------------------------
   */

  function updateSummary(
    container
  ) {
    const selectedItems =
      getSelectedItems(
        container
      );

    const footer =
      container.querySelector(
        '[data-complete-look-footer]'
      );

    const selectedText =
      container.querySelector(
        '[data-complete-look-selected-text]'
      );

    const total =
      container.querySelector(
        '[data-complete-look-total]'
      );

    /*
     * Nenhum complementar marcado.
     */
    if (!selectedItems.length) {
      footer?.classList.remove(
        'has-selection'
      );

      if (selectedText) {
        selectedText.textContent =
          '0 peças selecionadas';
      }

      if (total) {
        total.textContent =
          formatMoney(0);
      }

      return;
    }

    let totalCents = 0;

    /*
     * Complementares.
     */
    selectedItems.forEach(
      function (item) {
        totalCents +=
          Number(
            item.dataset.variantPrice ||
            0
          );
      }
    );

    /*
     * Produto principal.
     */
    const mainData =
      getMainVariantData(
        container
      );

    if (
      mainData &&
      mainData.variant
    ) {
      totalCents +=
        Number(
          mainData.variant.price ||
          0
        );
    }

    footer?.classList.add(
      'has-selection'
    );

    const totalPieces =
      selectedItems.length + 1;

    if (selectedText) {
      selectedText.textContent =
        'Look com ' +
        totalPieces +
        (
          totalPieces === 1
            ? ' peça'
            : ' peças'
        );
    }

    if (total) {
      total.textContent =
        formatMoney(
          totalCents
        );
    }
  }

  function syncWithMainProduct(
    container
  ) {
    const mainData =
      getMainVariantData(
        container
      );

    if (!mainData) {
      return;
    }

    container
      .querySelectorAll(
        '[data-complete-look-item]'
      )
      .forEach(
        function (item) {
          setInitialCardVariant(
            item,
            mainData.banho
          );
        }
      );

    updateSummary(
      container
    );
  }

  /*
   * --------------------------------------------------
   * CARRINHO
   * --------------------------------------------------
   */

  async function getCurrentCart() {
    const response =
      await fetch(
        '/cart.js',
        {
          method: 'GET',

          headers: {
            'Accept':
              'application/json',

            'Cache-Control':
              'no-cache'
          },

          cache:
            'no-store'
        }
      );

    if (!response.ok) {
      throw new Error(
        'Não foi possível consultar o carrinho.'
      );
    }

    return response.json();
  }

  function cartHasVariant(
    cart,
    variantId
  ) {
    if (
      !cart ||
      !Array.isArray(
        cart.items
      )
    ) {
      return false;
    }

    const targetId =
      String(
        variantId
      );

    return cart.items.some(
      function (item) {
        const cartVariantId =
          item.variant_id != null
            ? String(
                item.variant_id
              )
            : String(
                item.id
              );

        return (
          cartVariantId ===
          targetId
        );
      }
    );
  }

  /*
   * --------------------------------------------------
   * CART DRAWER ELYAH
   * --------------------------------------------------
   */

  function openElyahCartDrawer() {
    if (
      typeof theme !== 'undefined' &&
      theme.cart &&
      theme.cart.drawer &&
      typeof theme.cart.drawer.openDrawer ===
        'function'
    ) {
      theme.cart.drawer.openDrawer();

      return true;
    }

    return false;
  }

  /*
   * --------------------------------------------------
   * TRADUÇÃO DOS ERROS DA SHOPIFY
   * --------------------------------------------------
   */

  function getFriendlyCartError(
    message
  ) {
    const originalMessage =
      String(
        message || ''
      );

    const normalizedMessage =
      normalizeValue(
        originalMessage
      );

    /*
     * Não usamos "quantidade máxima".
     *
     * Isso poderia passar a impressão
     * de que existe um limite definitivo
     * de compra.
     */
    if (
      normalizedMessage.includes(
        'quantidade maxima'
      ) ||
      normalizedMessage.includes(
        'maximum quantity'
      ) ||
      normalizedMessage.includes(
        'maximum allowed'
      ) ||
      normalizedMessage.includes(
        'already have'
      )
    ) {
      return (
        'Um dos produtos selecionados já está no seu carrinho. ' +
        'Se quiser mais unidades, ajuste a quantidade diretamente no carrinho.'
      );
    }

    if (
      normalizedMessage.includes(
        'sold out'
      ) ||
      normalizedMessage.includes(
        'esgotado'
      )
    ) {
      return (
        'Um dos produtos selecionados ficou indisponível. ' +
        'Atualize sua seleção e tente novamente.'
      );
    }

    return (
      originalMessage ||
      'Não foi possível adicionar o look ao carrinho.'
    );
  }

  /*
   * --------------------------------------------------
   * ADICIONAR LOOK
   * --------------------------------------------------
   */

  async function addSelectedToCart(
    container,
    button
  ) {
    const selectedItems =
      getSelectedItems(
        container
      );

    if (!selectedItems.length) {
      return;
    }

    /*
     * Sempre limpa aviso anterior
     * ao iniciar uma nova tentativa.
     */
    hideMessage(
      container
    );

    const mainData =
      getMainVariantData(
        container
      );

    if (
      !mainData ||
      !mainData.variant ||
      !mainData.variant.id
    ) {
      showMessage(
        container,
        'Não foi possível identificar a peça principal.'
      );

      return;
    }

    button.disabled = true;

    const originalText =
      button.textContent;

    button.textContent =
      'ADICIONANDO LOOK...';

    try {
      /*
       * Consulta o carrinho real.
       */
      const cart =
        await getCurrentCart();

      const mainVariantId =
        String(
          mainData.variant.id
        );

      /*
       * Não repete o produto principal.
       */
      const mainAlreadyInCart =
        cartHasVariant(
          cart,
          mainVariantId
        );

      const items = [];

      /*
       * --------------------------------------------------
       * COMPLEMENTARES PRIMEIRO
       * --------------------------------------------------
       *
       * O drawer apresenta os itens novos
       * em ordem inversa.
       */
      selectedItems.forEach(
        function (item) {
          items.push({
            id: Number(
              item.dataset.variantId
            ),

            quantity: 1
          });
        }
      );

      /*
       * --------------------------------------------------
       * PRINCIPAL POR ÚLTIMO
       * --------------------------------------------------
       *
       * Assim ele tende a aparecer
       * visualmente no topo do drawer.
       */
      if (!mainAlreadyInCart) {
        const productDetail =
          container.closest(
            '.product-detail'
          );

        const quantityInput =
          productDetail?.querySelector(
            '.product-quantity__input'
          );

        const mainQuantity =
          Math.max(
            1,
            Number(
              quantityInput?.value ||
              1
            )
          );

        items.push({
          id: Number(
            mainVariantId
          ),

          quantity:
            mainQuantity
        });
      }

      if (!items.length) {
        throw new Error(
          'Nenhum item disponível para adicionar.'
        );
      }

      /*
       * Uma única requisição Shopify.
       */
      const response =
        await fetch(
          '/cart/add.js',
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify({
                items: items
              })
          }
        );

      let data = null;

      try {
        data =
          await response.json();
      } catch (jsonError) {
        throw new Error(
          'A Shopify retornou uma resposta inesperada.'
        );
      }

      if (
        !response.ok ||
        data.status
      ) {
        throw new Error(
          data.description ||
          data.message ||
          'Não foi possível adicionar o look.'
        );
      }

      /*
       * --------------------------------------------------
       * ABRE CARRINHO LATERAL
       * --------------------------------------------------
       */

      const drawerOpened =
        openElyahCartDrawer();

      if (!drawerOpened) {
        console.warn(
          'Complete seu Look: cart drawer não encontrado.'
        );

        window.location.href =
          '/cart';

        return;
      }

      /*
       * --------------------------------------------------
       * LIMPA CHECKBOXES
       * --------------------------------------------------
       *
       * Os banhos escolhidos permanecem.
       */
      container
        .querySelectorAll(
          '[data-complete-look-checkbox]'
        )
        .forEach(
          function (checkbox) {
            checkbox.checked =
              false;

            const item =
              checkbox.closest(
                '[data-complete-look-item]'
              );

            item?.classList.remove(
              'is-selected'
            );
          }
        );

      updateSummary(
        container
      );

    } catch (error) {
      console.error(
        'Complete seu Look:',
        error
      );

      showMessage(
        container,
        getFriendlyCartError(
          error.message
        )
      );

    } finally {
      button.disabled =
        false;

      button.textContent =
        originalText;
    }
  }

  /*
   * --------------------------------------------------
   * INICIALIZAÇÃO
   * --------------------------------------------------
   */

  function initCompleteLook(
    container
  ) {
    if (
      !container ||
      container.dataset.initialized ===
        'true'
    ) {
      return;
    }

    container.dataset.initialized =
      'true';

    /*
     * CHECKBOXES
     */
    container
      .querySelectorAll(
        '[data-complete-look-checkbox]'
      )
      .forEach(
        function (checkbox) {
          checkbox.addEventListener(
            'change',
            function () {
              /*
               * Qualquer nova interação
               * remove aviso antigo.
               */
              hideMessage(
                container
              );

              const item =
                checkbox.closest(
                  '[data-complete-look-item]'
                );

              if (item) {
                item.classList.toggle(
                  'is-selected',
                  checkbox.checked
                );
              }

              updateSummary(
                container
              );
            }
          );
        }
      );

    /*
     * BANHO INDIVIDUAL
     */
    container
      .querySelectorAll(
        '[data-complete-look-banho]'
      )
      .forEach(
        function (select) {
          select.addEventListener(
            'change',
            function () {
              hideMessage(
                container
              );

              const item =
                select.closest(
                  '[data-complete-look-item]'
                );

              if (!item) {
                return;
              }

              item.dataset.manualVariant =
                'true';

              const variant =
                findAvailableVariant(
                  item,
                  select.value
                );

              applyVariant(
                item,
                variant
              );

              updateSummary(
                container
              );
            }
          );
        }
      );

    /*
     * MUDANÇA DO PRODUTO PRINCIPAL
     */
    const productDetail =
      container.closest(
        '.product-detail'
      );

    if (productDetail) {
      const mainVariantInput =
        productDetail.querySelector(
          '.product-form input[name="id"]'
        );

      if (mainVariantInput) {
        mainVariantInput.addEventListener(
          'change',
          function () {
            hideMessage(
              container
            );

            setTimeout(
              function () {
                syncWithMainProduct(
                  container
                );
              },
              40
            );
          }
        );
      }

      const mainVariantContainer =
        productDetail.querySelector(
          '.product-variant'
        );

      if (mainVariantContainer) {
        mainVariantContainer.addEventListener(
          'change',
          function () {
            hideMessage(
              container
            );

            setTimeout(
              function () {
                syncWithMainProduct(
                  container
                );
              },
              60
            );
          }
        );
      }
    }

    /*
     * BOTÃO ADICIONAR LOOK
     */
    const addButton =
      container.querySelector(
        '[data-complete-look-add]'
      );

    if (addButton) {
      addButton.addEventListener(
        'click',
        function () {
          addSelectedToCart(
            container,
            addButton
          );
        }
      );
    }

    /*
     * Primeira sincronização.
     */
    syncWithMainProduct(
      container
    );
  }

  function initAll() {
    document
      .querySelectorAll(
        '[data-complete-look]'
      )
      .forEach(
        function (container) {
          initCompleteLook(
            container
          );
        }
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }

  /*
   * Editor visual Shopify.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      initAll();
    }
  );

})();